var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.2,492c-4.3-3.4-9-6.4-12.9-10.2c-67.5-67.4-135-134.8-202.4-202.3c-1.5-1.5-2.8-3.2-5.9-6.8 c-1.6,2.7-2.3,4.9-3.8,6.4c-67.5,67.6-135.1,135.2-202.8,202.8c-3.9,3.8-8.6,6.8-12.9,10.2c-2.9,0-5.8,0-8.6,0c-6-2.6-10.3-7-13-13 c0-2.9,0-5.8,0-8.6c3.6-4.5,6.9-9.5,11-13.6c67.2-67.4,134.6-134.7,201.9-202c1.4-1.4,3-2.5,5-4.2c-2-2.1-3.4-3.6-4.9-5.1 C152.4,176.8,83.8,108.3,15.2,39.6C4.7,29.1,8.1,13.4,21.7,9.7c7.1-1.9,12.9,0.6,18,5.8c33.3,33.4,66.7,66.7,100,100 c35.1,35.1,70.3,70.2,105.4,105.4c1.4,1.4,2.6,3,4.3,5c2-1.9,3.5-3.3,5-4.8c68.7-68.7,137.4-137.5,206.1-206.2 c5.5-5.5,11.6-8.5,19.4-5.9c11.9,4,15.7,18.1,7.6,27.6c-1.4,1.6-3,3.1-4.5,4.6c-68.1,68.1-136.2,136.2-204.2,204.3 c-1.4,1.4-2.7,2.8-5.2,5.5c2,1.4,4,2.3,5.5,3.8c68.8,68.7,137.5,137.4,206.2,206.1c10.8,10.8,8.3,23.6-5.8,30.2 c-0.3,0.1-0.4,0.5-0.7,0.8C476,492,473.1,492,470.2,492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2a7b40fd51c00cc8c1e62d69b0be750d.svg";
export { ForwardRef as ReactComponent };